import script from "./PricingServices.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingServices.vue?vue&type=script&setup=true&lang=js"

import "./PricingServices.vue?vue&type=style&index=0&id=b991cfa2&scoped=true&lang=css"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b991cfa2"]])

export default __exports__